// extracted by mini-css-extract-plugin
var _1 = "ReorderGutterButton-module__animateUploadProgressBarWidth--QR8oU";
var _2 = "ReorderGutterButton-module__animatedBackground--b80mu";
var _3 = "ReorderGutterButton-module__attachment--URVh4";
var _4 = "ReorderGutterButton-module__button--OdUkq";
var _5 = "ReorderGutterButton-module__container--cK2jV";
var _6 = "ReorderGutterButton-module__dragging--tn6cd";
var _7 = "ReorderGutterButton-module__dropPlaceholder--Z7Tzr";
var _8 = "12px";
var _9 = "ReorderGutterButton-module__list--zIAHm";
var _a = "ReorderGutterButton-module__reorderGhost--DnuSX";
var _b = "ReorderGutterButton-module__snapshotContainer--h6xLu";
var _c = "ReorderGutterButton-module__snapshotDragHandler--pYfwS";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "attachment", _4 as "button", _5 as "container", _6 as "dragging", _7 as "dropPlaceholder", _8 as "iconSize", _9 as "list", _a as "reorderGhost", _b as "snapshotContainer", _c as "snapshotDragHandler" }
